import React from 'react';
import BaseLayout from './base.js';
import Testimonial from '../testimonial.js';

/*---------------------------------------------*/

export default class ThumbnailsLayout extends BaseLayout {
	constructor(props) {
		super(props);

		this.selectedThumbRef = React.createRef();
		
		this.state = {
			...this.state,
			index: 0
		}
	}

	render() {
		let items = this.props.items.slice(0,7);
		let paddingLeftRight = this.context.get('layout.padding.leftright',40,24);
		let paddingTopBottom = this.context.get('layout.padding.topbottom',40,24);

		let thumb = (this.selectedThumbRef && this.selectedThumbRef.current);
		let thumbnailOffset = thumb ? (thumb.offsetLeft-this.container.current.offsetLeft) : 0;
		
		let styles = {
			container: {
				paddingLeft: paddingLeftRight,
				paddingRight: paddingLeftRight,
				paddingTop: paddingTopBottom,
				paddingBottom: paddingTopBottom
			},
			partsContainer: {
				display: 'grid',
				gridTemplateColumns: '100%' // prevents from children exceed grid width
			},
			testimonial: {
				width: '100%',
				padding: 0
			},
			navigation: {
				container: {
					whiteSpace: 'nowrap'
				},
				item: {
					display: 'inline-block',
					cursor: 'pointer',
					verticalAlign: 'middle'
				}
			}
		}

		let topParts = items.map((item,i) => {
			let style = {
				gridColumn: 1,
				gridRow: 1,
				visibility: (i === this.state.index) ? 'visible' : 'hidden'
			}

			return (
				<div style={style} key={i}>
					<Testimonial part='top' thumbnailOffset={thumbnailOffset} data={item} />
				</div>
			);
		});

		let bottomParts = items.map((item,i) => {
			let style = {
				gridColumn: 1,
				gridRow: 1,
				visibility: (i === this.state.index) ? 'visible' : 'hidden'
			}

			return (
				<div style={style} key={i}>
					<Testimonial part='bottom' thumbnailOffset={thumbnailOffset} data={item} />
				</div>
			);
		});

		let thumbnails = items.map((item,i) => {
			let onClick = () => this.setState({index: i});
			let isSelected = (i===this.state.index);

			let props = {
				part: 'thumbnail', 
				selected: isSelected,
				first: (i===0), 
				last: (i===items.length-1), 
				data: item
			}
			
			return (
				<div style={styles.navigation.item} onClick={onClick} key={i} ref={isSelected ? this.selectedThumbRef : null}>
					<Testimonial {...props} />
				</div>
			)
		})

		let content = [
			<div style={styles.partsContainer} key='top'>
				{topParts}
			</div>,
			<div style={styles.navigation.container} key='thumbnails'>
				{thumbnails}
			</div>,
			<div style={styles.partsContainer} key='bottom'>
				{bottomParts}
			</div>
		]

		return (
			<div className="thumbnails" style={styles.container} ref={this.container}>
				<Testimonial content={content} baseStyle={styles.testimonial} />
			</div>
		)
	}
}

/*---------------------------------------------*/
/*---------------------------------------------*/